.organisasjonsnummer {
  display: flex;
  gap: var(--dds-spacing-small-4);
}
